<template>
  <section class="section">
    <v-container v-resize="onResize">
      <h1 style="text-align:center; font-size:50px; line-height:1.1em;">
        <span style="font-size:70px;">10 razões</span>
        <br>para estudar na escola
        <br>
        <img src="/images/logo-nome-simples.svg" style="height:90px;">
      </h1>
      <v-timeline :dense="dense" clipped>
        <v-timeline-item
          v-for="(o, i) in items"
          :key="i"
          :color="o.color"
          fill-dot
          :icon="o.icon"
        >
          <!-- <template v-slot:opposite>
            <h2 class="font-weight-black display-1" style="color:#666">{{o.number}}</h2>
          </template> -->
          <v-card>
            <v-card-title :class="o.colorTitle">
              <v-icon dark size="42" class="mr-3">mdi-magnify</v-icon>
              <h2 class="display-1 white--text font-weight-light">
                {{o.number}}.
                {{o.title}}
              </h2>
            </v-card-title>
            <v-container>
              <v-layout>
                <v-flex xs10>{{o.content}}</v-flex>
                <v-flex xs2>
                  <v-icon size="64">mdi-calendar-text</v-icon>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-container>
  </section>
</template>

<script>
export default {
  mounted() {
    this.onResize();
  },
  methods: {
    onResize: function() {
      this.dense = window.innerWidth < 700;
    }
  },
  data: () => ({
    dense: false,
    items: [
      {
        number: "1",
        color: "blue lighten-1",
        colorTitle: "grey",
        icon: "location_on",
        title: "Localização",
        content:
          "A Escola Engenho situa-se no Campeche, a 1500 metros do trevo que dá acesso à praia pela Av. Pequeno Príncipe. Sendo perto da sua casa ou do seu bairro, não é necessário o deslocamento até o Centro em busca de uma boa formação para seus filhos."
      },
      {
        number: "2",
        color: "orange darken-1",
        colorTitle: "grey",
        icon: "grade",
        title: "Proposta",
        content:
          "No processo de interação do educando com educadores e colegas, a aprendizagem informal propicia condições para a estrutura da aprendizagem sistematizada. O lúdico e o afeto permeiam nossa prática do desenvolvimento da autonomia e dos valores culturais."
      },
      {
        number: "3",
        color: "blue lighten-1",
        colorTitle: "grey",
        icon: "group",
        title: "Composição dos Grupos",
        content:
          "Turmas pequenas possibilitam, por parte da equipe pedagógica, o acompanhamento integral do desenvolvimento de cada aluno."
      },
      {
        number: "4",
        color: "orange darken-1",
        colorTitle: "grey",
        icon: "public",
        title: "Meio Ambiente",
        content:
          "A Escola Engenho entende que assuntos como o equilíbrio da natureza, consumo consciente e preservação dos recursos naturais, são assuntos que devem perpassar os conteúdos em sala de aula."
      },
      {
        number: "5",
        color: "blue lighten-1",
        colorTitle: "grey",
        icon: "memory",
        title: "Novas Tecnologias",
        content:
          "As novas tecnologias são utilizadas por professores e alunos como recurso para o processo de ensino-aprendizagem. Estão inseridas no dia a dia das salas de aula multimídia, que possibilitam maior acesso à informação e dinamização das aulas, empregando diferentes linguagens."
      },
      {
        number: "6",
        color: "orange darken-1",
        colorTitle: "grey",
        icon: "restaurant_menu",
        title: "Alimentação",
        content:
          "Tanto teoricamente, nas discussões em aula, quanto na prática, com a mesa de frutas e sucos naturais, preparados para a hora do recreio, incentivamos o consumo de alimentos naturais, evitando a ingestão de sódio, conservantes e açúcar refinado."
      },
      {
        number: "7",
        color: "blue lighten-1",
        colorTitle: "grey",
        icon: "terrain",
        title: "Aulas de Campo",
        content:
          "Visitas monitoradas em ambientes onde os alunos reconhecem e aplicam conhecimentos teóricos desenvolvidos em sala de aula."
      },
      {
        number: "8",
        color: "orange darken-1",
        colorTitle: "grey",
        icon: "perm_identity",
        title: "Profissionais Qualificados",
        content:
          "Professores com formação universitária em sua área de conhecimento e formação continuada em reuniões e supervisões pedagógicas, além de incentivo anual para cursos de aperfeiçoamento."
      },
      {
        number: "9",
        color: "blue lighten-1",
        colorTitle: "grey",
        icon: "favorite",
        title: "Convívio",
        content:
          "Vivência respeitosa entre alunos, equipe pedagógica, funcionários e pais ou responsáveis, de maneira a proporcionar uma formação de qualidade, ampliando o exercício da autonomia, da solidariedade e do respeito às diferenças."
      },
      {
        number: "10",
        color: "orange darken-1",
        colorTitle: "grey",
        icon: "cake",
        title: "Experiência",
        content:
          "A escola vem escrevendo a sua história na comunidade, proporcionando educação de qualidade e contribuindo para a formação de indivíduos que possam ser mais criativos, respeitosos e responsáveis. Este é o diferencial da Engenho."
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: right;
}
</style>
